var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[(_vm.skeleton)?_c('v-skeleton-loader',{attrs:{"width":"100%","type":_vm.skeleton}}):_c('div',{staticClass:"lds-ripple"},[_c('div',{style:({ 'border-color': _vm.rippleColor })}),_c('div',{style:({ 'border-color': _vm.rippleColor })})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }